import { handleActions } from 'redux-actions';
import * as filtersActions from '../actions/filters';

let initState = {
  count: 0,
  fields: null,
  search: null,
  typeList: null,
};

export const filters = handleActions(
  {
    [filtersActions.updateFilterFieldsOffers]: (state, action) => {
      return {
        ...state,
        fields: action.payload,
      };
    },
    [filtersActions.searchOffers]: (state, action) => {
      return {
        ...state,
        search: action.payload,
      };
    },
    [filtersActions.changeTypeListOffers]: (state, action) => {
      return {
        ...state,
        typeList: action.payload,
      };
    },
    [filtersActions.countFiltersOffers]: (state, action) => {
      return {
        ...state,
        count: action.payload,
      };
    },
    [filtersActions.resetFiltersOffers]: (state, action) => {
      return {
        ...state,
        fields: null,
        search: null,
        count: 0,
      };
    },
  },
  initState
);
